export const chatbotReducer = (state = { loadingChatbot: false, resultchatbot: null, chatbotdata: {}, chatbotmessages: [], chatbotLogs: [], loadingLogs: false, myChatHistory: [], loadingHistory: false }, action) => {
    switch (action.type) {
        case 'CHATBOT_HISTORY_LOADING':
            return {
                ...state,
                loadingHistory: true
            }

        case 'CHATBOT_HISTORY_SUCCESS':
            return {
                ...state,
                loadingHistory: false,
                myChatHistory: action.payload || []
            }

        case 'CHATBOT_HISTORY_ERROR':
            return {
                ...state,
                loadingHistory: false
            }

        case 'CHATBOT_RESTORE_MESSAGES':
            return {
                ...state,
                chatbotmessages: [...(action.payload || [])],
                resultchatbot: null,
                chatbotdata: {}
            }

        case 'CHATBOT_LOG_LOADING':
            return {
                ...state,
                loadingLogs: true
            }

        case 'CHATBOT_LOG_SUCCESS':
            return {
                ...state,
                loadingLogs: false,
                chatbotLogs: action.payload || []
            }

        case 'CHATBOT_LOG_ERROR':
            return {
                ...state,
                loadingLogs: false
            }

        case 'CHATBOT_SUCCESS':
            return {
                ...state,
                loadingChatbot: false,
                resultchatbot: action.payload,
                chatbotdata: action.payload,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    {
                        role: 'assistant',
                        content: action.payload.reply || ''
                    }
                ]
            }

        case 'CHATBOT_LOADING':
            return {
                ...state,
                loadingChatbot: true
            }

        case 'CHATBOT_NOT_LOADING':
            return {
                ...state,
                loadingChatbot: false
            }

        case 'CHATBOT_ADD_USER_MESSAGE':
            return {
                ...state,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    action.payload
                ]
            }

        case 'CHATBOT_ADD_BOT_MESSAGE':
            return {
                ...state,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    action.payload
                ]
            }

        case 'CHATBOT_CLEAR_MESSAGES':
            return {
                ...state,
                chatbotmessages: [],
                resultchatbot: null,
                chatbotdata: {}
            }

        default:
            return state
    }
}